module.exports = __webpack_public_path__ + "img/wizard-03@2x.c02ac024.png";